// Five events, five distinct strings — never compose one from another or
// reuse one for a different cause.
export const SCHEDULE_OVERRIDE_MESSAGES = {
    fingerprint:
        'The vehicle or product changed, so the service schedule was re-derived. Your date changes and start-service choice have been cleared.',
    malformed:
        'Your saved date changes could not be read, so they and your start-service choice have been cleared and the schedule was re-derived.',
    expired:
        'This quote has aged and one or more of your edited service dates has passed. All your date changes have been cleared and the schedule re-derived. Your start-service choice is unchanged.',
    unhonoured:
        'Your saved date changes could no longer be applied to this quote, so they have been cleared and the schedule was re-derived. Your start-service choice is unchanged.',
    refusedEdit:
        'That date could not be applied to this service. Nothing has been changed — choose another date, or tick "Also update the following services" to move the ones after it.',
} as const;
